import * as React from 'react';

function SvgConfirmAccount(props) {
  return (
    <svg
      width={64}
      height={64}
      viewBox="38 30 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_887_23872)">
        <rect x={38} y={30} width={64} height={64} rx={4} fill="#00F399" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M70 76C73.713 76 77.274 74.525 79.8995 71.8995C82.525 69.274 84 65.713 84 62C84 58.287 82.525 54.726 79.8995 52.1005C77.274 49.475 73.713 48 70 48C66.287 48 62.726 49.475 60.1005 52.1005C57.475 54.726 56 58.287 56 62C56 65.713 57.475 69.274 60.1005 71.8995C62.726 74.525 66.287 76 70 76ZM76.4872 59.7372C76.806 59.4072 76.9824 58.9651 76.9784 58.5063C76.9744 58.0475 76.7904 57.6085 76.4659 57.2841C76.1415 56.9596 75.7025 56.7756 75.2437 56.7716C74.7849 56.7676 74.3428 56.944 74.0128 57.2628L68.25 63.0255L65.9872 60.7628C65.6572 60.444 65.2151 60.2676 64.7563 60.2716C64.2975 60.2756 63.8585 60.4596 63.5341 60.7841C63.2096 61.1085 63.0256 61.5475 63.0216 62.0063C63.0176 62.4651 63.194 62.9072 63.5128 63.2372L67.0128 66.7372C67.3409 67.0653 67.786 67.2496 68.25 67.2496C68.714 67.2496 69.1591 67.0653 69.4872 66.7372L76.4872 59.7372Z"
          fill="#191936"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_887_23872"
          x={0}
          y={0}
          width={144}
          height={144}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx={2} dy={10} />
          <feGaussianBlur stdDeviation={20} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0771875 0 0 0 0 0.197678 0 0 0 0 0.7125 0 0 0 0.01 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_887_23872"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_887_23872"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default SvgConfirmAccount;
